import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AlertDialogOptions } from './alert-dialog-options';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { H4Component } from '@design-system/typography/h4/h4.component';
import { WarningIconComponent } from '@design-system/layout/warning-icon/warning-icon.component';

/**
 * Standard inline replacement for javascript alert().
 * A useful modal dialog in which to ensure a user sees a message.
 * See {@link OnScreenMessagingService#openAlertDialog} for usage
 */
@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    H4Component,
    WarningIconComponent
  ]
})
export class AlertDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: AlertDialogOptions,
    private sanitizer: DomSanitizer
  ) {}

  sanitizeMessage(message: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(message);
  }
}
